import lighten from 'polished/lib/color/lighten';
import shade from 'polished/lib/color/shade';
import tint from 'polished/lib/color/tint';

/**
 * Brands can provide as many colours as required. Each key should be a
 * color name (e.g. 'red' or 'mySpecialRed').
 *
 * "dark" and "light" are special keys: they are not used to generate
 * UI variants (e.g. primary/secondary buttons), but as accent/background
 * alongside the other named colors. They will default to black and white.
 */
const brandColors = {
  pink: '#E91E63',
  blue: '#039BE5',
  dark: '#000',
  light: '#fff'
};

/**
 * Each brand can provide optional accent colors. These should be used
 * sparingly, and only in brand-specific component variants.
 **/
const brandAccents = {
  lime: '#93F811'
};
const alerts = {
  info: '#e8f4fd',
  error: '#fdecea',
  warning: '#fff4e5',
  success: '#edf7ed'
};
const palette = {
  primary: {
    light: lighten(0.08, brandColors.pink),
    main: brandColors.pink,
    dark: shade(0.16, brandColors.pink),
    contrastText: '#fff',
    contrastTextLight: brandColors.dark
  },
  secondary: {
    light: tint(0.16, brandColors.blue),
    main: brandColors.blue,
    dark: shade(0.16, brandColors.blue),
    contrastText: '#fff',
    contrastTextLight: brandColors.dark
  }
};
const opacities = {
  default: 'rgba(255,255,255,0.33)',
  subtle: 'rgba(255,255,255,0.16)',
  strong: 'rgba(255,255,255,0.66)',
  inverted: 'rgba(0,0,0,0.16)',
  invertedSubtle: 'rgba(0,0,0,0.06)',
  invertedStrong: 'rgba(0,0,0,0.33)'
};
const darkOpacities = {
  default: 'rgba(0,0,0,0.16)',
  subtle: 'rgba(0,0,0,0.06)',
  strong: 'rgba(0,0,0,0.33)',
  inverted: 'rgba(255,255,255,0.33)',
  invertedSubtle: 'rgba(255,255,255,0.16)',
  invertedStrong: 'rgba(255,255,255,0.66)'
};
const text = {
  text: brandColors.dark,
  textMuted: '#707070',
  contrastText: brandColors.light
};
const darkText = {
  text: brandColors.light,
  textMuted: '#ececec',
  contrastText: brandColors.dark
};

/** Neutral shades for borders etc. */
const accents = {
  light: tint(0.85, brandColors.pink),
  dark: brandColors.dark,
  muted: '#ececec'
};
const darkAccents = {
  light: '#efefef',
  dark: '#000',
  muted: '#484848'
};
const colors = {
  ...palette,
  ...text,
  brandAccents,
  accents,
  alerts,
  opacities,
  background: brandColors.light,
  surface: '#f7f7f7'
};
const darkColors = {
  ...colors,
  ...darkText,
  opacities: darkOpacities,
  accents: darkAccents,
  background: brandColors.dark,
  surface: '#343434'
};

export { colors, darkColors, palette };
